import { AuthContext } from '@repo-level/core-front';
import navDeskSrc from 'assets/images/quest/nav-desk.webp';
import { useTheme } from 'hooks/theme';
import { EMissionMode, useQuestPromo } from 'modules/quest/hooks';
import type { FC } from 'react';
import { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'react-navi';
import missionContainerSrc from '../../../../../assets/images/quest/mission-container.webp';
import { ScAuroraPanel } from './styled';

export interface IQuestPanelProps {
  onLinkClick?: () => void;
}

export const QuestPanel: FC<IQuestPanelProps> = memo(({ onLinkClick }) => {
  const { t } = useTranslation('quest');

  const { isAuthenticated } = useContext(AuthContext);

  const { images } = useTheme();

  const { navigate } = useNavigation();

  const { currentMission } = useQuestPromo();

  if (!currentMission) return null;
  const { foregroundSrc, completeImg, mode } = currentMission;

  const dashboardKey =
    mode === EMissionMode.AVAILABLE ? 'activeMission' : 'completeMission';

  return (
    <ScAuroraPanel
      onClick={() => {
        onLinkClick && onLinkClick();
        navigate('/quest');
      }}
    >
      <img alt="background" className="bg" src={navDeskSrc} />
      <div className="inner">
        <div className="content">
          <div className="content-text">
            <Display
              className="mobile"
              completeImg={completeImg}
              foregroundSrc={foregroundSrc}
            />
            <div className="title">
              <Display
                className="desktop"
                completeImg={completeImg}
                foregroundSrc={foregroundSrc}
              />

              <p>Elf's Gift Machine</p>
            </div>
          </div>
          {isAuthenticated && (
            <p className="message-2 desktop">
              {t(`dashboard.${dashboardKey}`)}
            </p>
          )}
        </div>
        <div className="mobile">
          <images.arrowRightSmallIcon.component />
        </div>
      </div>
    </ScAuroraPanel>
  );
});

interface IDisplayProsp {
  className: string;
  completeImg: string | undefined;
  foregroundSrc: string | undefined;
}

const Display: FC<IDisplayProsp> = ({
  className,
  completeImg,
  foregroundSrc,
}) => (
  <div className={`display ${className}`}>
    <img alt="mission bg" className="background" src={missionContainerSrc} />
    {completeImg && (
      <img alt="mission inactive" className="prize" src={completeImg} />
    )}
    {foregroundSrc && (
      <img alt="diamond" className="foreground" src={foregroundSrc} />
    )}
  </div>
);
